import React from 'react'; //eslint-disable-line
import { Icon } from 'antd';

export default function({ component, text }) {
	return (
		<span>
			<Icon 
				component={component} 
				style={{ marginRight: 8 }}
			/>
			{text}
		</span>
	);
}



// WEBPACK FOOTER //
// ./src/components/Items/ItemAction.js